import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  /** Use scale-up effect instead of slide-up */
  scale?: boolean;
}

/**
 * Wraps content and reveals it with a fade + slide (or scale) when it scrolls into view.
 */
export const ScrollReveal: React.FC<ScrollRevealProps> = ({ children, className = '', scale = false }) => {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
  const baseClass = scale ? 'scroll-reveal-scale' : 'scroll-reveal';
  return (
    <div
      ref={ref}
      className={`${baseClass} ${isVisible ? 'scroll-reveal-visible' : ''} ${className}`.trim()}
    >
      {children}
    </div>
  );
};
